import mixpanel from 'mixpanel-browser';
import firebase from 'firebase/app';

export default class TrackerService {

  constructor(props) {
    this.props = props;

    let baseData = null;

    if (props.object) {
      baseData = {
        // Customer
        distinct_id: props.object.striker_userId,
  
        // Client
        clientId: props.object.clientId,
        displayName: props.object.displayName,
  
        // Tag
        tagId: props.object.tagId || props.tagId,
        currency: (props.object.paymentDetails) ? (props.object.paymentDetails.currency || 'EUR') : 'EUR',
        product: props.object.product || 'tipping',
        placeOfWork: props.object.placeOfWork,
  
        // Tap
        tapId: props.ds_tapid || props.tapId,
        tagUid: props.tagUid,
        source: props.source,
        paidFees: (props.paymentDetails) ? props.paymentDetails.shouldAddOnFees : false,
      };
    }

    // Use test Mixpanel project for localhost/emulator; live for production
    const isLocalOrEmulator = typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    const isTest = isLocalOrEmulator || props.isTest || (props.object && props.object.is_test);

    this.state = {
      isTest,
      baseData,
    }
    
    if (this.state.isTest) {
      mixpanel.init("d640916443dff1f8941cd617479bc3e2", { "api_host": "https://api-eu.mixpanel.com" }, "");
    } else {
      mixpanel.init("69b491f259aef50b30c75e03f0f31b37", { "api_host": "https://api-eu.mixpanel.com" }, "");
    }
  }

  intValuesToDecimals({ amount, fee }) {
    const decimalAmount = (parseInt(amount) / 100).toFixed(2);
    const decimalFee = (parseInt(fee) / 100).toFixed(2);
    return {
      decimalAmount,
      decimalFee
    };
  }


  getMixpanelTrackData(name, data) {
    return {
      ...this.state.baseData,
      ...data,
    };
  }

  getGoogleTrackData(name, data) {
    return data;
  }

  mixPanelIdentify(userId, clientId, displayName, email) {
    mixpanel.identify(userId);
    if (displayName && email) {
      mixpanel.people.set({
        '$name': displayName,
        '$email': email,
        'clientId': clientId,
      });
    }
  }

  // options (optional) is passed straight to mixpanel.track, e.g. { transport: 'sendBeacon' }
  // for events fired right before navigation so they aren't dropped by the page change.
  // Only forwarded when provided, so existing two-arg callers are unchanged.
  mixpanelTrack(name, data, options) {
    const props = this.getMixpanelTrackData(name, data);
    if (options) mixpanel.track(name, props, options);
    else mixpanel.track(name, props);
  }

  googleTrack(name, data) {
    // Analytics is not initialized on localhost (see index.js) — calling it here would
    // lazily init Installations and reproduce the app-offline rejection in dev.
    if (window.location.hostname === 'localhost') return;
    firebase.analytics().logEvent(name, this.getGoogleTrackData(name, data));
  }

  /** Build standard claim payload with templateTagId, partnerClientId when available */
  static buildClaimPayload(tag, client, uid, extra = {}) {
    return {
      tagId: tag?.id,
      templateTagId: tag?.templateTagId || null,
      partnerClientId: tag?.partnerClientId || null,
      clientId: client?.id,
      distinct_id: uid,
      product: tag?.product,
      isTeamTag: !!tag?.isTeamTag,
      ...extra,
    };
  }

}